import { render, staticRenderFns } from "./section5.vue?vue&type=template&id=bf5ff894"
import script from "./section5.vue?vue&type=script&lang=js"
export * from "./section5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports